import { Pipe, PipeTransform } from '@angular/core';
import {
    IntegrationState,
    IntegrationStateMetadata,
    IntegrationStateMetadataMap
} from '../../views/admin/application-settings/models/integration-state.model';

@Pipe({
    name: 'ngcIntegrationStateMetadata'
})
export class IntegrationStateMetadataPipe implements PipeTransform {

    transform(state: IntegrationState): IntegrationStateMetadata {
        return IntegrationStateMetadataMap.get(state);
    }

}
